import { Injectable } from '@angular/core';
import { BaseService } from '@common';
import { MarkQuestion } from '@fuulea/mark-paper';

// 无状态工具服务，注册到 root 便于全屏 Overlay 里创建的组件（如作答复核查看器）注入；组件级 providers 仍优先
@Injectable({ providedIn: 'root' })
export class MarkUtilsService extends BaseService {
  loadTaskPhotogroup(taskId: number) {
    return this.doGet<MarkQuestion[]>(`/tasks/${taskId}/photogroup/`);
  }
}
